module.exports = __webpack_public_path__ + "static/media/brokerTitle.a33ceea1.png";